import React from 'react';
import { MobileChildSupport } from './MobileChildSupport';
import { MobileDivorce } from './MobileDivorce';

export const MobileServicesPrices = () => {
  return (
    <div
      className="services-prices mobile-services-prices"
      id="services-prices"
    >
      <div className="services-prices-heading">
        <p>Ціни {'&'} Послуги</p>
      </div>
      <MobileChildSupport />
      <MobileDivorce />
    </div>
  );
};
